import React from 'react';

const CircleTick = ({ color = '#616161', width = 24, height = 24, ...rest }, ref) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_26794_206099)">
        <path
          d="M6.66797 10.4141L9.16797 12.9141L13.3346 7.91406"
          stroke={color}
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0013 18.3307C14.6037 18.3307 18.3346 14.5998 18.3346 9.9974C18.3346 5.39502 14.6037 1.66406 10.0013 1.66406C5.39893 1.66406 1.66797 5.39502 1.66797 9.9974C1.66797 14.5998 5.39893 18.3307 10.0013 18.3307Z"
          stroke={color}
          stroke-width="1.66667"
        />
      </g>
      <defs>
        <clipPath id="clip0_26794_206099">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.forwardRef(CircleTick);
